var map = {
	"./about/lang/da.lang.json": 331,
	"./about/lang/en.lang.json": 332,
	"./case/lang/da.lang.json": 333,
	"./case/lang/en.lang.json": 334,
	"./contact/lang/da.lang.json": 335,
	"./contact/lang/en.lang.json": 336,
	"./core/lang/da.lang.json": 337,
	"./core/lang/en.lang.json": 338,
	"./index/lang/da.lang.json": 339,
	"./index/lang/en.lang.json": 340,
	"./layout/lang/da.lang.json": 341,
	"./layout/lang/en.lang.json": 342,
	"./login/lang/da.lang.json": 343,
	"./login/lang/en.lang.json": 344,
	"./press/lang/da.lang.json": 345,
	"./press/lang/en.lang.json": 346,
	"./service/lang/da.lang.json": 347,
	"./service/lang/en.lang.json": 348,
	"./technology/lang/da.lang.json": 349,
	"./technology/lang/en.lang.json": 350
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 329;


//////////////////
// WEBPACK FOOTER
// ./src/app lang.json
// module id = 329
// module chunks = 1